export default "__VITE_PUBLIC_ASSET__4a458f7c__"